import { Grid, Typography } from "@mui/material"

const BannerReport = ({color,name,number}) => {
    return (
    <Grid container sx={{alignItems:"stretch"}}>
        <Grid display={"flex"} flexDirection={"column"} alignItems={"center"} size={12} sx={{padding:{xs:"16px",sm:"20px 24px",md:"20px 48px"}, backgroundColor:color}}>
            <Typography variant="h5" fontWeight={600} color="white" textAlign="center" sx={{wordBreak:"break-word"}}>Section {number}</Typography>
            <Typography variant="h5" fontWeight={400} color="white" textAlign="center" sx={{wordBreak:"break-word"}}>{name}</Typography>
        </Grid>
    </Grid>    
    )
}

export default BannerReport